import { isCompletedShipment } from './cancellation';
import { normalizePlate } from './serialNumbers';

const text = value => String(value || '').trim();
const key = value => text(value).toLocaleUpperCase('tr-TR').replace(/\s+/g, ' ');
const tons = row => { const value = Number(String(row.miktarTon || 0).replace(',', '.')); return Number.isFinite(value) ? value : 0; };
const transportRows = rows => rows.filter(row => isCompletedShipment(row) && row.teslimTipi === 'INOSEL_TESLIM');

export function calendarDayCount(start, end) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(start || '') || !/^\d{4}-\d{2}-\d{2}$/.test(end || '')) return 0;
  const first = Date.parse(`${start}T00:00:00Z`), last = Date.parse(`${end}T00:00:00Z`);
  return Number.isFinite(first) && Number.isFinite(last) && last >= first ? Math.round((last - first) / 86400000) + 1 : 0;
}

export function transportMetrics(rows) {
  const records = transportRows(rows);
  const identified = records.filter(row => normalizePlate(row.plaka) || row.plateId);
  const vehicleCount = new Set(identified.map(row => normalizePlate(row.plaka) || `id:${row.plateId}`)).size;
  return { ton: records.reduce((sum, row) => sum + tons(row), 0), trips: records.length, vehicleCount,
    averageVehicleTon: vehicleCount ? identified.reduce((sum, row) => sum + tons(row), 0) / vehicleCount : 0,
    averageTrips: vehicleCount ? identified.length / vehicleCount : 0 };
}

export function driverPerformance(rows, regions = [], dayCount = 1) {
  if (!Number.isFinite(dayCount) || dayCount <= 0) return [];
  const groups = new Map();
  const records = transportRows(rows);
  const knownIds = new Map();
  for (const row of records) if (row.soforId && text(row.soforAdi)) {
    const name = key(row.soforAdi);
    if (!knownIds.has(name)) knownIds.set(name, new Set());
    knownIds.get(name).add(row.soforId);
  }
  for (const row of records) {
    const driverName = text(row.soforAdi);
    if (!row.soforId && !driverName) continue;
    const region = regions.find(r => r.id === row.bolgeId) || regions.find(r => key(r.ad) === key(row.operasyonBolgesi));
    const regionKey = region?.id || row.bolgeId || key(row.operasyonBolgesi) || 'unknown';
    if (!groups.has(regionKey)) groups.set(regionKey, { id: regionKey, name: region?.ad || text(row.operasyonBolgesi) || 'Bölge belirtilmedi', drivers: new Map() });
    const group = groups.get(regionKey);
    const matches = knownIds.get(key(driverName));
    const driverId = row.soforId || (matches?.size === 1 ? [...matches][0] : '');
    const driverKey = driverId ? `id:${driverId}` : `name:${key(driverName)}`;
    if (!group.drivers.has(driverKey)) group.drivers.set(driverKey, { id: driverKey, name: driverName || 'Adı kaydedilmemiş şoför', ton: 0, trips: 0 });
    const driver = group.drivers.get(driverKey);
    driver.ton += tons(row); driver.trips += 1;
  }
  return [...groups.values()].map(group => {
    const drivers = [...group.drivers.values()].map(driver => ({ ...driver, dailyAverageTon: driver.ton / dayCount })).sort((a, b) => b.dailyAverageTon - a.dailyAverageTon || a.name.localeCompare(b.name, 'tr') || a.id.localeCompare(b.id));
    const topCount = Math.min(2, Math.ceil(drivers.length / 2));
    const top = drivers.slice(0, topCount);
    const bottom = drivers.slice(topCount).reverse().slice(0, 2);
    return { id: group.id, name: group.name, driverCount: drivers.length, top, bottom,
      averageTon: drivers.reduce((sum, driver) => sum + driver.ton, 0) / dayCount / drivers.length,
      averageTrips: drivers.reduce((sum, driver) => sum + driver.trips, 0) / drivers.length };
  }).sort((a, b) => a.name.localeCompare(b.name, 'tr'));
}
